import React from 'react';
import { CardBase, HTML, Image } from '../../components';
import { block } from '../../utils';
import './Partner.css';
const b = block('partner-block');
const Partner = ({ text, logo, url, border }) => {
    const logoData = typeof logo === 'string' ? { src: logo } : logo;
    return (React.createElement(CardBase, { url: url, target: "_blank", className: b(), border: border },
        React.createElement(CardBase.Content, null,
            React.createElement(Image, Object.assign({ className: b('logo') }, logoData)),
            React.createElement(HTML, null, text))));
};
export default Partner;
